<template>
  <div class="col-md-12" style="border: 1px solid black">
    <h4>Transport Certificate Approval</h4>
    <hr />
    <br />
    <div>
      <b-card>
        <div>
          <b-form @submit.stop.prevent>
            <div class="form-group row">
              <label
                for="staticEmail"
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
                >Tag No.</label
              >
              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                <b-form-input
                  id="input-small"
                  size="sm"
                  v-model="name"
                  placeholder=""
                  readonly
                ></b-form-input>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="staticEmail"
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
                >Certificate No.</label
              >
              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                <b-form-input
                  id="input-small"
                  size="sm"
                  v-model="certicate_no"
                  placeholder=""
                  readonly
                ></b-form-input>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="staticEmail"
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
                >Breed</label
              >
              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                <b-form-input
                  id="input-small"
                  v-model="from"
                  size="sm"
                  placeholder=""
                  readonly
                ></b-form-input>
              </div>
            </div>
            <div class="form-group row">
              <label
                for="staticEmail"
                class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-4 col-form-label"
                >Remark</label
              >
              <div class="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-8">
                <b-form-textarea
                  id="textarea-default"
                  placeholder=""
                  v-model="remark"
                ></b-form-textarea>
              </div>
            </div>
            <br />
            <div class="col-md-12">
              <center>
                <b-button variant="primary" @click="handleSubmit"
                  >Approve</b-button
                >&nbsp;
                <b-button variant="danger" @click="handleBack">Cancel</b-button>
              </center>
            </div>
            <br />
          </b-form>
        </div> </b-card
      ><br />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      remark: "",
    };
  },
  methods: {
    handleSubmit() {
      alert("Approval Success");
    },
    handleBack(){
        this.$router.go(-1);
    }
  },
};
</script>
